/*globals $*/
'use strict';

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
delete L.Icon.Default.prototype._getIconUrl;

const url = $('#directorio').val();
const lang = $('#actual-languaje').val();

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const LeafIcon = L.Icon.extend({
    options: {
        iconSize:     [53, 64],
        iconAnchor:   [26, 63],
        popupAnchor:  [-1, -62]
    }
});

const mainIcon = new LeafIcon({iconUrl: url+'/assets/images/map-spot.png'});

//import mapboxgl from 'mapbox-gl';
const mapBoxAccessToken = 'pk.eyJ1Ijoic2xpbmdzaG90MDgiLCJhIjoiY2p3dDAycGJoMGFpazN5bXU4bnUwNXpweiJ9.CsRpsYoETLpHG72jaOIEUQ';

var markersGroup = [];
var angrupMap = false;

export const initMap = (tab) => {

    $('.map__overlay-loader').show();

    var windowWidth = $(window).width();
    var bcnPoints = 0;

    //$('#map__container_content').removeClass('map__container_background');
    //$('.map__overlay').hide();

    var isMap = $('#general__map').attr('data-map');
    if(isMap == 'false'){
        /*if( windowWidth < 800 ){ 
            if( $('#map__container_content').hasClass('map__container_full') ){
                $('#map__container_content').removeClass('map__container_full');
            }else{
                $('#map__container_content').addClass('map__container_full');
            }
        }*/

        $('#general__map').attr('data-map', 'true');
        $('#general__map').css('background-image', 'none');

        var pageId = $('#general__map').attr('data-pageid');
        var pageType = $('#general__map').attr('data-pagetype');

        if(angrupMap == false){

            angrupMap = L.map('general__map').setView([40.8964112, 0.6793699], 16);
            

            // adding the /256/ avoids the 512 by default, which has a too small text
            /*L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/{id}/tiles/256/{z}/{x}/{y}?access_token={accessToken}', {
                attributionControl: false,
                //maxZoom: 18,
                //id: 'light-v9',
                id: 'streets-v12',
                accessToken: mapBoxAccessToken
            }).addTo(angrupMap);*/

            //mapa satelite
            L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{
                attributionControl: false,
                maxZoom: 18,
                subdomains:['mt0','mt1','mt2','mt3']
            }).addTo(angrupMap);


            angrupMap.zoomControl.setPosition('bottomleft');
            angrupMap.scrollWheelZoom.disable();

            $('.leaflet-control-attribution').hide();
            $('.leaflet-control').css('border', '0px');

            $.ajax({
                type: "GET",
                url: url + '/src/Services/Resources/Manager/get_map_points.php?lang=ca&pageid=44',
                success: function(data) {
                    console.log(data);
                    var markers = JSON.parse( data );
                    for ( var m in markers ){
                        makeMarker(m, markers, angrupMap, markersGroup);
                        bcnPoints = bcnPoints + 1;

                    }
                },
                async: false
            });
            //fitBoundsCity(markersGroup);
        }

    }

    $('.map__overlay-loader').hide();

};

function fitBoundsCity(markerGroup){
    var group = L.featureGroup(markerGroup).addTo(angrupMap);
    angrupMap.fitBounds(group.getBounds());
}

var customOptions =
    {
    'maxWidth': '250',
    'className' : 'custom-infowindow'
    }

function makeMarker(m, markers, map, markersGroup){
    markersGroup.push( L.marker( [ markers[m]['latitude'], markers[m]['longitude'] ], {customId: markers[m]['id'], info: JSON.stringify(markers[m]), icon: mainIcon} ).addTo(map).bindPopup('<h1 class="map__window_title">'+markers[m]['title']+'</h1>'+markers[m]['text']+'<a href="'+markers[m]['url']+'" target="_blank" class="calltoaction white">GOOGLE MAPS</a>', customOptions ) ); //on('click', onMarkerClick )
}
/*
function onMarkerClick(e){
    var infoMarker = JSON.parse( this.options.info );

    $('#map__window_image').attr('src', infoMarker['image']);
    $('#map__window_book-link').attr('href', infoMarker['reservation_url']);
    $('#map__window_web-link').attr('href', infoMarker['website_url']);
    $('#map__window_facebook-link').attr('href', infoMarker['facebook_url']);
    $('#map__window_instagram-link').attr('href', infoMarker['instagram_url']);
    $('#map__window_twitter-link').attr('href', infoMarker['twitter_url']);
    $('#map__window_googlemaps-link').attr('href', infoMarker['google_url']);

    $('#map__window_title').empty();
    $('#map__window_address').empty();
    $('#map__window_phone').empty();

    $('#map__window_title').append(infoMarker['title']);
    $('#map__window_address').append(infoMarker['address']);
    $('#map__window_phone').append(infoMarker['telephone']);

    $('#map__window').show();
}

export const closeInfowindow = () => {
    $('#map__window_image').attr('src', '');
    $('#map__window_book-link').attr('href', '');
    $('#map__window_web-link').attr('href', '');
    $('#map__window_facebook-link').attr('href', '');
    $('#map__window_instagram-link').attr('href', '');
    $('#map__window_twitter-link').attr('href', '');
    $('#map__window_googlemaps-link').attr('href', '');

    $('#map__window_title').empty();
    $('#map__window_address').empty();
    $('#map__window_phone').empty();

    $('#map__window').hide();
};
*/